export const RECOMMENDATIONS_SHELF_TYPE = 'recommendations'
export const CATEGORY_SHELF_TYPE = 'category'
export const CATEGORY_SAVINGS_SHELF_TYPE = 'category_savings'
export const BUY_AGAIN_SAVINGS_SHELF_TYPE = 'buy_again_savings'
export const DISCOVERY_PRODUCTS_SHELF_TYPE = 'discovery products'
export const DID_YOU_FORGET_SHELF_TYPE = 'did you forget'
export const CAMPAIGN_PROMOS_SHELF_TYPE = 'campaign_promos'
export const FEATURED_PROMOTIONS_SHELF_TYPE = 'featured promotion category'
export const TRENDING_ITEMS_SHELF_TYPE = 'trending_items'

export const BUY_AGAIN_SINGLE_RETAILER_TYPE = 'buy_again_single_retailer'

export enum SHELF_RENDER_TYPE {
  PRODUCT = 'product',
  FEATURED_PROMOTIONS = 'featured promotions',
  CAMPAIGN_PROMOS = 'campaign_promos',
  BUY_AGAIN_SINGLE_RETAILER = 'buy_again_single_retailer',
}

export const SHELF_ITEM_WIDTH = 154
export const HERO_SHELF_ITEM_WIDTH = 264
